<template>

	<v-dialog
			@keydown.esc="closeDialog"
			max-width="1400px"
			persistent
			v-model="$store.getters.bookInfoDialog">
		<v-card style=" height: 90vh;overflow-y: auto;" class="gradient-border-card d-flex flex-column">
			<v-card-title class="headline white--text"
						  style="background: #11254d;background: linear-gradient(90deg,rgba(17, 37, 77, 1) 0%, rgba(17, 113, 112, 1) 50%, rgba(21, 168, 147, 1) 100%);">
				<span class="text-truncate" style="max-width: 110ch">{{book.title}}</span>
				<v-spacer/>
				<v-btn color="white" icon @click="closeDialog">
					<v-icon large>close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text>
				<v-row justify="center">
					<v-col cols="5" class="ma-0 pa-0 mt-3">

						<v-tabs
								v-model="tab"
								centered
								height="45px"
								icons-and-text
								light>
							<v-tabs-slider color="secondary"/>
							<v-tab>Εξώφυλλο</v-tab>
							<v-tab>Οπισθόφυλλο</v-tab>
						</v-tabs>

						<v-tabs-items v-model="tab">
							<v-tab-item>
								<v-row justify="center">
									<v-col cols="11">
										<v-img :src="cover" class="white--text" max-width="450px" contain/>
									</v-col>
								</v-row>
							</v-tab-item>

							<v-tab-item>
								<v-row justify="center">
									<v-col cols="11">
										<v-img :src="backCover" class="white--text" max-width="450px" contain/>
									</v-col>
								</v-row>
							</v-tab-item>
						</v-tabs-items>
					</v-col>

					<v-col cols="7" class="ma-0 pa-0 mt-3  d-flex flex-column">

						<h2 style="color: #11455B" class="mt-4"> Στοιχεία Συγγράμματος</h2>
						<v-divider class="mt-2"/>
						<v-card class="mt-4">

							<v-row justify="center">
								<v-col cols="8" class="px-1 mx-0">

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Υπότιτλος
											</v-list-item-title>
											<v-list-item-subtitle>
												<span class="text-truncate">
												  {{ book.subtitle }}
												</span>

												<v-tooltip color="primary"  bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-icon
															class="ml-2"
															color="primaryLighter"
															v-bind="attrs"
															v-on="on">
															mdi-magnify-expand
														</v-icon>
													</template>

													<div class="authors-tip pa-2">
														{{ book.subtitle }}
													</div>
												</v-tooltip>
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Κωδικός Βιβλίου στον Εύδοξο
											</v-list-item-title>
											<v-list-item-subtitle>{{book.id}}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title>Συγγραφείς</v-list-item-title>

											<v-list-item-subtitle >
												<span class="text-truncate">
												  {{ book.authors }}
												</span>

												<v-tooltip color="primary"  bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-icon
																class="ml-2"
																color="primaryLighter"
																v-bind="attrs"
																v-on="on">
															mdi-magnify-expand
														</v-icon>
													</template>

													<div class="authors-tip pa-2">
														{{ book.authors }}
													</div>
												</v-tooltip>
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Διαθέτης (Εκδότης)</v-list-item-title>
											<v-list-item-subtitle>{{book.publisherName}}
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Εκδόσεις</v-list-item-title>
											<v-list-item-subtitle>{{book.editorialHouse}}
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Λέξεις Κλειδιά
												<v-icon @click="openKeywordsDialog" color="primaryLighter">
													mdi-magnify-expand
												</v-icon>
											</v-list-item-title>
											<v-list-item-subtitle>{{keywords}}
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item v-if="book.type==='ProfessorNotes'">
										<v-list-item-content>
											<v-list-item-title> Άδεια </v-list-item-title>
											<v-list-item-subtitle>
												<a :href="'https://creativecommons.org/licenses/by-nc-nd/3.0/deed.el'" target="_blank" rel="noopener noreferrer">
													{{book.licenseId}}
												</a>
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-subtitle>
												<v-chip style="max-width: 200px" outlined v-if="book.pathToTOC"
														color="primaryLighter"><h5>Πίνακας
													Περιεχομένων </h5>
													<v-icon @click="openBookFilePdf(book.pathToTOC)"
															color="primaryLighter"> visibility
													</v-icon>
												</v-chip>
												<v-chip style="max-width: 200px" outlined v-if="book.pathToChapter"
														color="primaryLighter"><h5>Ενδεικτικό
													Απόσπασμα </h5>
													<v-icon @click="openBookFilePdf(book.pathToChapter)"
															color="primaryLighter"> visibility
													</v-icon>
												</v-chip>
												<v-chip style="max-width: 200px" outlined v-if="book.pathToFile && book.type==='ProfessorNotes'"
														color="primaryLighter"><h5> Αρχείο </h5>
													<v-icon @click="openBookFilePdfFromBackEnd(book.id)"
															color="primaryLighter"> mdi-cloud-download
													</v-icon>
												</v-chip>
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

								</v-col>

								<v-col cols="4" class="px-1 mx-0">

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> ISBN</v-list-item-title>
											<v-list-item-subtitle>{{book.isbn}}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Τύπος</v-list-item-title>
											<v-list-item-subtitle>{{(utils.returnBookType(book.type))}}
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Αριθμός Έκδοσης</v-list-item-title>
											<v-list-item-subtitle>{{book.editionNumber}}
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Έτος Τρέχουσας Έκδοσης
											</v-list-item-title>
											<v-list-item-subtitle>{{book.publicationYear}}
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Δέσιμο</v-list-item-title>
											<v-list-item-subtitle>{{book.type ==='ProfessorNotes'||'eBook'? 'Χωρίς' : utils.getBindingTypeGreekString(book.binding)}}
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Διαστάσεις</v-list-item-title>
											<v-list-item-subtitle>{{book.dimensions}}
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Αριθμός Σελίδων</v-list-item-title>
											<v-list-item-subtitle>{{book.pages}}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-list-item-content>
											<v-list-item-title> Ιστοσελίδα Βιβλίου</v-list-item-title>
											<v-list-item-subtitle>
												<span v-if="book.linkToPublisher== null"> Χωρίς </span>
												<span v-else style="color: darkslategrey" @click="confirmWindowOpen(book.linkToPublisher)">Εδώ</span>
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>


								</v-col>
							</v-row>
						</v-card>

					</v-col>

				</v-row>

			</v-card-text>
		</v-card>
		<v-dialog v-model="keywordsDialog" max-width="700px">
			<v-card  class="gradient-border-card d-flex flex-column">
<!--				<v-data-table-->
<!--						:headers="[{ text: '', value: 'keyword', align: 'center' }]"-->
<!--						:items="book.keywords" items-per-page="10" hide-default-header-->
<!--						item-value="." @click:outside="keywordsDialog=false"-->
<!--						:search="search" dense >-->
<!--					<template v-slot:top>-->
<!--						<v-text-field-->
<!--								v-model="search"-->
<!--								label="Search "-->
<!--								class="mx-2"-->
<!--						></v-text-field>-->
<!--					</template>-->
<!--					<template v-slot:item.keyword="{ item }">-->
<!--						{{ item }}-->
<!--					</template>-->
<!--				</v-data-table>-->
				<v-data-table
						:headers="[{ text: '', value: 'keyword', align: 'center' }]"
						:items="(book.keywords || []).map(k => ({ keyword: k }))"
						hide-default-header
						:search="search"
						dense>
					<template v-slot:top>
						<v-text-field
								v-model="search"
								label="Search"
								class="mx-2"
						></v-text-field>
					</template>

					<template v-slot:item.keyword="{ item }">
						{{ item.keyword }}
					</template>
				</v-data-table>

			</v-card>
		</v-dialog>
		<CustomWindowConfirm ref="confirmDialog"/>
	</v-dialog>
</template>

<script>
	import utils from '../utilities'
	import CustomWindowConfirm from "./CustomWindowConfirm";
	import requests from "../requests";
	export default {
		name: "BookInfoDialog",
		components: {CustomWindowConfirm},
		props: {
			book: Object
		},
		data: () => ({
			typeSelector: [
				{label: 'Σύγγραμμα', value: 'Published'},
				{label: 'Ηλεκτρονικό Βιβλίο', value: 'eBook'},
				{label: 'Δωρεάν Ηλεκτρονικό Βοήθημα / Σημειώσεις', value: 'ProfessorNotes'}
			],
			tab: 0,
			searchResults: [],
			defaultCover: require('../assets/blank.png'),
			cover: null,
			backCover: null,
			search: '',
			subjects: '',
			keywords: '',
			keywordsDialog: false,
		}),
		methods: {

			openBookFilePdfFromBackEnd(bookId){
				document.activeElement.blur();
				this.$store.commit('setLoadingModal', true);
				requests.postForFiles('rest/app/get-book-pdf', {id:bookId}, this.getResultPdfFileCallBack);
			},

			getResultPdfFileCallBack(response) {
				this.$store.commit('setLoadingModal', false);
				utils.downLoadPDFNewTab(response);
			},

			async confirmWindowOpen(url){
				const ok = await this.$refs.confirmDialog.show({
					message: 'Θα ανακατευθυνθείτε προς τον ορισμένο από τον εκδότη ιστότοπο, ' + url + ' .Για να συνεχίσετε πατήστε επιβεβαίωση'
				});
				// If you throw an error, the method will terminate here unless you surround it wil try/catch

				if (ok) {
					window.open(url, "_blank", "noopener,noreferrer");
				}
			},

			closeDialog() {
				this.$store.commit('setBookInfoDialog', false);
			},

			openKeywordsDialog(){
				this.keywordsDialog = true;
				document.activeElement.blur();
			},


			openBookFilePdf(url) {
				document.activeElement.blur();
				window.open(utils.reformatBookPath(url), '_blank');
			},

			async getCover(pathToCover) {
				if (!pathToCover) return this.defaultCover;
				const url = utils.reformatBookPath(pathToCover);
				return new Promise((resolve) => {
					const img = new Image();
					img.onload = () => resolve(url);
					img.onerror = () => resolve(this.defaultCover);
					img.src = url;
				});
			},

			async loadCovers() {
				this.cover = await this.getCover(this.book.pathToCover);
				this.backCover = await this.getCover(this.book.pathToBackcover);
			},

		},

		computed: {
			utils() {
				return utils
			}
		},

		created() {
			this.loadCovers();

			if (this.book.subjects && this.book.subjects.length > 0) {
				this.subjects = this.book.subjects.join(", ");
			}
			if (this.book.keywords && this.book.keywords.length > 0) {
				this.keywords = this.book.keywords.join(", ");
			}
		}
	}
</script>

<style scoped>
	.gradient-border-card {
		border: 4px solid transparent;
		border-image: linear-gradient(
				90deg,
				rgba(17, 37, 77, 1) 0%,
				rgba(17, 113, 112, 1) 50%,
				rgba(21, 168, 147, 1) 100%
		);
		border-image-slice: 1;
		border-radius: 0 !important;
	}
	.authors-tooltip-content{
		background: transparent !important; /* remove vuetify grey */
		opacity: 1 !important;             /* no transparency */
		padding: 0 !important;             /* so only your div defines padding */
	}

	/* your custom bubble */
	.authors-tip{
		width: 320px;
		max-width: 320px;
		white-space: normal;
		overflow-wrap: anywhere;
		word-break: break-word;

		background-color: #11254D; /* your blue */
		color: #fff;
		border-radius: 6px;
	}



</style>